type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  strokeWidth?: string;
};

/** The sibling of ChevronDownIcon, pointing right: "this leads on". */
const ChevronRightIcon = (props: Props) => {
  const {
    width = '10',
    height = '10',
    viewBox = '0 0 10 10',
    strokeColor = 'currentColor',
    strokeWidth = '1.5',
  } = props;
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M3.5 2L6.5 5L3.5 8"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronRightIcon;
